import { ContactUsPageTranslations } from '../types';

export const translations: ContactUsPageTranslations = {
  docTitle: 'Communiquez avec nous',
  pageTitle: 'Communiquez avec nous',
  beforeUnloadPrompt: 'Souhaitez-vous quitter cette page? Les changements apportés ne seront peut-être pas sauvegardés.',
  form: {
    submitSuccessMessage: 'Le formulaire a été soumis correctement.',
    field: {
      name: {
        label: 'Nom',
        placeHolder: 'Nom',
        error: {
          required: 'Veuillez saisir votre prénom.',
          tooShort: 'Le champ Nom doit comporter au moins 2 caractères.',
          tooLong: 'Le champ Nom ne doit pas comporter plus de 80 caractères.'
        }
      },
      email: {
        label: 'Adresse courriel',
        placeHolder: 'julietremblay@exemple.com',
        pattern: '^[a-zA-Z0-9_\\-][a-zA-Z0-9_\\.\\-]*@[a-zA-Z0-9][a-zA-Z0-9\\-]*(\\.[a-zA-Z0-9]+)+$',
        error: {
          required: 'Veuillez saisir votre adresse courriel.',
          tooShort: 'Veuillez saisir une adresse courriel valide (p. ex., julietremblay@exemple.com).',
          tooLong: 'Veuillez saisir une adresse courriel valide (p. ex., julietremblay@exemple.com).',
          patternMismatch: 'Veuillez saisir une adresse courriel valide (p. ex., julietremblay@exemple.com).'
        }
      },
      details: {
        label: 'Détails',
        placeHolder: 'Renseignements sur votre demande',
        error: {
          required: 'Veuillez entrer les détails concernant votre demande.'
        }
      }
    },
    action: {
      submit: {
        label: 'Envoyer'
      }
    }
  },
  addressContent: [
    '<p><span class="sr-only">Numéro de téléphone :</span> <a href="tel:+1-866-327-3078" style="white-space:nowrap">1 866 327-3078</a></p>',
    '<p><span class="sr-only">Adresse courriel :</span> <a href="mailto:info@engardeprotection.com">info@engardeprotection.com</a></p>',
    '<p><span class="sr-only">Adresse :</span> C.P. 3020',
    '<br />Succursale D',
    '<br />Toronto, Ontario <span style="white-space:nowrap">M9C 4V5</span></p>'
  ].join('\n')
};
